import BaseModelAPI from '../BaseModelAPI';

export default class DocumentLocationList extends BaseModelAPI {

	static entity = 'documentlocationlist'
	static entityName = 'documentlocation';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
